import { AccountSearchInterface } from "../interface/searchInterface";

export const searchInit : AccountSearchInterface = {
    keywordType : '0',
    keyword : '',
    limit : 10,
    pageNo : 1,
}